import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEmployeePhotoState } from "models/Slices/employeeSlice.model";
import { employeePhotoAsync } from "redux/actions/EmployeePhoto.action";
import { IEmployeeProfilePhotoResponse } from "models/Employee/employeeProfile.model";

const initialState: IEmployeePhotoState = {
  employeePhoto: null,
  loading: false,
  error: "",
  success: false,
};

export const employeePhotoSlice = createSlice({
  name: "employeePhoto",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(employeePhotoAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        employeePhotoAsync.fulfilled,
        (state, action: PayloadAction<IEmployeeProfilePhotoResponse>) => {
          state.loading = false;
          state.employeePhoto = action.payload;
          state.success = !state.employeePhoto?.ErrorCode ? true : false;
        }
      )
      .addCase(employeePhotoAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export default employeePhotoSlice.reducer;
